import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const HeatSensitiveModal = ({ className, open, handleClose, handleContinue, disableButtons }) => (
  <Dialog
    aria-describedby="scroll-dialog-description"
    aria-labelledby="scroll-dialog-title"
    className={className}
    fullWidth
    maxWidth="xs"
    onClose={handleClose}
    open={open}
    PaperProps={{ className: 'dialogPaper' }}
  >
    <DialogTitle className="dialogTitleRoot" disableTypography id="scroll-dialog-title">
      <h3>HEAT-SENSITIVE ITEMS</h3>
      <IconButton
        aria-label="close"
        className="closeButton"
        onClick={handleClose}
        disabled={disableButtons}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      <Typography className="body2Root" variant="body2" gutterBottom>
        At least one item in your cart is heat-sensitive and should not be left outside if no one is
        available to receive the delivery. If no one will be available on weekends, you will need to
        check the &apos;Hold until Monday&apos; checkbox to delay delivery until a weekday.
      </Typography>
      <Button
        className="buttonRoot"
        color="primary"
        disabled={disableButtons}
        onClick={handleClose}
        variant="contained"
      >
        GO BACK
      </Button>
      <Button
        className="buttonRoot"
        color="secondary"
        disabled={disableButtons}
        onClick={handleContinue}
        variant="outlined"
      >
        CONTINUE ANYWAY
      </Button>
    </DialogContent>
  </Dialog>
)

HeatSensitiveModal.defaultProps = {
  className: '',
}

HeatSensitiveModal.propTypes = {
  className: PropTypes.string,
  disableButtons: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleContinue: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
}

const StyledHeatSensitiveModal = styled(HeatSensitiveModal)(
  /**
   * @param {DefaultTheme} theme
   */
  ({ theme }) => ({
    h3: {
      color: theme.colors.grayscale.white,
    },
    '.dialogPaper': {
      bottom: '0',
      left: '0',
      margin: '0',
      maxWidth: 'unset',
      position: 'absolute',
      right: '0',
      width: '100%',
    },
    '.body2Root': {
      fontSize: '16px',
      lineHeight: '27px',
      marginBottom: '20px',
    },
    '.buttonRoot': {
      width: 'calc(50% - 4px)',
      '&:first-of-type': {
        marginRight: '8px',
      },
    },
    '.closeButton': {
      color: theme.colors.grayscale.white,
      position: 'absolute',
      right: '12px',
      top: '12px',
      '&:hover': {
        backgroundColor: 'initial',
      },
    },
    '.dialogTitleRoot': {
      alignItems: 'center',
      display: 'flex',
      height: '73px',
      '& h3': {
        margin: '0',
      },
    },
    '@media(min-width: 600px)': {
      '.dialogPaper': {
        margin: '0 auto',
        position: 'relative',
        width: '414px',
      },
    },
  }),
)

export default StyledHeatSensitiveModal
